import React from 'react'
import { HIGHLIGHT_COLOR_OPTIONS } from '../../../../utils/constants'
import { CheckIcon } from '../../../../dbWebUI'
import { Button, Box } from '@deseretbook/react-ui'
import PropTypes from 'prop-types'

import './HighlightOptions.css'

/**
 * Renders style picker options for editing the highlight.
 *
 * @returns {function} Component
 */
const HighlightOptions = ({ highlight, isLoading, activeButton, onClick }) => {
  return (
    <Box id="HighlightOptionsContainer">
      {HIGHLIGHT_COLOR_OPTIONS.map((color, index) => {
        const isActive = color.value === highlight.color
        const showLoading = isLoading && color.value === activeButton

        return (
          <Button
            isStatic={isActive || showLoading}
            isLoading={showLoading}
            title={color.label}
            style={{
              background: color.hex,
              marginRight: index === 4 || index === 9 ? 0 : '16px',
              marginTop: index > 4 ? '16px' : 0,
            }}
            onClick={() => onClick('color', color.value)}
            className="highlight-color"
          >
            {!!isActive && <CheckIcon className={`color-check`} />}
          </Button>
        )
      })}
    </Box>
  )
}

HighlightOptions.propTypes = {
  highlight: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  activeButton: PropTypes.string.isRequired,
}

HighlightOptions.defaultProps = {
  highlight: {},
  isLoading: false,
  activeButton: '',
}

export default HighlightOptions
